import classNames from 'classnames'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useAds } from '@/contexts/ads'

import styles from './UVPPlus.module.scss'

const UVPPlus = () => {
  const { loadAds } = useAds()

  if (!loadAds) {
    return <div className={styles.placeholder}></div>
  }

  return (
    <div className={classNames(styles.container, 'shadow-sm', { 'dev-ad': process.env.NODE_ENV !== 'production' })}>
      <div
      /* className={classNames(styles.uvpPlus, {
          'mv-video-target mv-video__featured mv-video__optimized': process.env.NODE_ENV === 'production',
        })}
        data-autoinsert='true'
        data-automobile='true'
        data-autoplay='true'
        data-disable-jsonld='true'
        data-disable-optimize='true'
        data-muted='true'
        data-playlist-id='upnext'
        data-sticky='true' */
      />
      <OutboundLink url='https://patreon.com/edhrec' utm_medium='please_support_us'>
        <div className={styles.centeredOutboundLink}>
          Please consider supporting us on Patreon to remove ads for only $2/month.
        </div>
      </OutboundLink>
    </div>
  )
}

export default UVPPlus
